import { useEffect, useRef } from "react";

export default function EmberCanvas({ density = 46 }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h;
    const mouse = { x: -999, y: -999 };

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const spawn = () => ({
      x: Math.random() * w,
      y: h + Math.random() * h * 0.4,
      r: 0.6 + Math.random() * 2.2,
      vy: 0.25 + Math.random() * 0.9,
      vx: (Math.random() - 0.5) * 0.35,
      a: 0.25 + Math.random() * 0.55,
      flick: Math.random() * Math.PI * 2,
      hue: Math.random() > 0.75 ? "18, 100%, 55%" : "42, 90%, 60%",
    });

    let parts = Array.from({ length: density }, () => {
      const p = spawn();
      p.y = Math.random() * h;
      return p;
    });

    const onMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    };
    window.addEventListener("mousemove", onMove);

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      for (const p of parts) {
        p.flick += 0.06;
        p.y -= p.vy;
        p.x += p.vx + Math.sin(p.flick) * 0.18;
        const dx = p.x - mouse.x;
        const dy = p.y - mouse.y;
        const dist = Math.hypot(dx, dy);
        if (dist < 90) {
          p.x += (dx / dist) * 0.7;
          p.y += (dy / dist) * 0.7;
        }
        if (p.y < -12) Object.assign(p, spawn());
        const alpha = p.a * (0.65 + 0.35 * Math.sin(p.flick));
        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 5);
        grad.addColorStop(0, `hsla(${p.hue}, ${alpha})`);
        grad.addColorStop(1, `hsla(${p.hue}, 0)`);
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 5, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    tick();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, [density]);

  return <canvas ref={ref} className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true" />;
}
